import { mapGetters } from 'vuex';
import { getComponentBySchemaName } from './templateMapping';
import { isDesktop } from '../../utils/deviceType';

export default {
  computed: {
    ...mapGetters(
      'instantSavings',
      ['offers', 'orderUuid'],
    ),
    desktopSchemaNames() {
      return [
        'MGO Advantage Print Default',
        'MGO Advantage Print Comcast',
      ];
    },
    // Array order matters - the last schema name
    // that matches an offer schema will be favored
    mobileSchemaNames() {
      return [
        'MGO Advantage Mobile Full Page Default',
        'MGO Advantage Mobile Full Page Expanded',
      ];
    },
    templateComponent() {
      const { schema } = this.template;
      return schema ? getComponentBySchemaName(schema.name) : null;
    },
  },
  data() {
    return {
      offer: null,
      template: null,

      // query params
      offsrc: '', // 'amp'
      ref: '',
      specId: '',
    };
  },
  created() {
    // Get query params
    if (this.$route.path.indexOf('/r/') > -1) {
      this.offsrc = 'amp';
      this.ref = 'sms';
    } else {
      this.offsrc = this.$route.query.offsrc || '';
      this.ref = this.$route.query.ref || '';
    }
    this.specId = this.$route.query.specId || '';

    const { orderUuid } = this.$route.params;
    this.$store.set('instantSavings/orderUuid', orderUuid);
  },
  async mounted() {
    await this.$store.dispatch('instantSavings/getToken');
    await this.$store.dispatch('instantSavings/getOffers', {
      schemas: isDesktop() ? this.desktopSchemaNames : this.mobileSchemaNames,
    });

    const offer = this.getOfferById(this.specId);
    this.offer = offer;
    const template = this.getTemplate();
    this.template = template;

    if (this.offer && this.refId) {
      this.$coa.trackEngagement(this.refId, [this.offer.id]);
    }
  },
  methods: {
    getOfferById(adId) {
      const [offer] = this.offers.filter(({ id }) => id.toString() === adId);
      return offer || null;
    },
    getTemplate() {
      const { templates } = this.offer;
      const template = templates.filter(({ schema: { name } }) => {
        if (isDesktop()) {
          return this.desktopSchemaNames.indexOf(name) > -1;
        }
        return this.mobileSchemaNames.indexOf(name) > -1;
      }).pop();

      return template || {};
    },
    printOffer() {
      window.print();
      window.close();
    },
  },
};
